export default {
  schedule: {
    type: Object,
    default: () => {}
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/components/schedule/resources/props.js